import React, {useState} from "react";
import {Container, Nav, Navbar} from "react-bootstrap";
import "animate.css";

const TopMenu: React.FC = () => {
    const [expanded, setExpanded] = useState(false);

    const handleNavClick = (e: React.MouseEvent, id: string) => {
        setExpanded(false);
        const el = document.getElementById(id);
        if (el) {
            const offset = 0;
            const top = el.getBoundingClientRect().top + window.scrollY + offset;
            window.scrollTo({top, behavior: 'smooth'});
        }
    };

    return (
        <Navbar
            bg="dark"
            variant="dark"
            expand="sm"
            expanded={expanded}
            onToggle={setExpanded}
            className="topBar fixed-top"
        >
            <Container fluid className="mainMenu">
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav" className="navBarCollapseCustom">
                    <Nav className="ms-auto me-auto">
                        <Nav.Link onClick={(e) => {
                            e.preventDefault();
                            handleNavClick(e, "pomarrosa")
                        }}><strong>POMARROSA</strong></Nav.Link>
                        <Nav.Link
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavClick(e, "mercadotecnia")
                            }}>MERCADOTECNIA</Nav.Link>
                        <Nav.Link onClick={(e) => {
                            e.preventDefault();
                            handleNavClick(e, "disenio")
                        }}>DISEÑO</Nav.Link>
                        <Nav.Link onClick={(e) => {
                            e.preventDefault();
                            handleNavClick(e, "web")
                        }}>WEB</Nav.Link>
                        <Nav.Link onClick={(e) => {
                            e.preventDefault();
                            handleNavClick(e, "imagen")
                        }}>IMAGEN</Nav.Link>
                        <Nav.Link onClick={(e) => {
                            e.preventDefault();
                            handleNavClick(e, "marcas")
                        }}>MARCAS</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default TopMenu;
